import { Route, Routes } from "react-router-dom";
import { LandingPage } from "./LandingPage";
import { MarketingLayout } from "./MarketingLayout";
import { PricingPage } from "../billing/PricingPage";
import { TermsPage } from "../legal/TermsPage";
import { PrivacyPage } from "../legal/PrivacyPage";
import { RefundPage } from "../legal/RefundPage";
import { ContactPage } from "../contact/ContactPage";
import { HelpPage } from "../help/HelpPage";
import { CookieConsent } from "../shell/CookieConsent";
import { ErrorBoundary } from "../shell/ErrorBoundary";
import { NotFoundPage } from "../shell/NotFoundPage";
import { initSentry } from "../observability/sentry";

export function MarketingApp() {
  return (
    <ErrorBoundary>
      <Routes>
        <Route element={<MarketingLayout />}>
          <Route path="/" element={<LandingPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/legal/terms" element={<TermsPage />} />
          <Route path="/legal/privacy" element={<PrivacyPage />} />
          <Route path="/legal/refund" element={<RefundPage />} />
          <Route path="/contact-us" element={<ContactPage />} />
          <Route path="/help" element={<HelpPage />} />
          <Route
            path="*"
            element={<NotFoundPage homeTo="/" homeLabel="Back to home" />}
          />
        </Route>
      </Routes>
      <CookieConsent
        onChange={(value) => {
          if (value === "accepted") initSentry();
        }}
      />
    </ErrorBoundary>
  );
}
